import React, { useState, useEffect } from 'react';
import { restaurantService } from '../services/dataService';
import MenuManagement from './dashboard/MenuManagement';
import TableManagement from './dashboard/TableManagement';

const ManagerDashboard = ({ restaurant }) => {
  const [menu, setMenu] = useState([]);
  const [tables, setTables] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (restaurant) {
      loadData();
    }
  }, [restaurant]);

  const loadData = async () => {
    try {
      const [menuResult, tablesResult] = await Promise.all([
        restaurantService.getMenu(restaurant.id),
        restaurantService.getTables(restaurant.id)
      ]);

      if (menuResult.error) throw menuResult.error;
      if (tablesResult.error) throw tablesResult.error;

      setMenu(menuResult.data || []);
      setTables(tablesResult.data || []);
    } catch (error) {
      console.error('Error loading data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)'
      }}>
        <div style={{
          background: 'white',
          padding: '40px',
          borderRadius: '20px',
          textAlign: 'center',
          boxShadow: '0 10px 40px rgba(0,0,0,0.1)'
        }}>
          <div style={{
            width: '50px',
            height: '50px',
            border: '4px solid #FF4444',
            borderTop: '4px solid transparent',
            borderRadius: '50%',
            margin: '0 auto 20px',
            animation: 'spin 1s linear infinite'
          }} />
          <h2 style={{ color: '#333', margin: '0' }}>Loading Manager Dashboard...</h2>
        </div>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  return (
    <div style={{
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      minHeight: 'calc(100vh - 90px)'
    }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '30px 20px' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: '2.5fr 1.5fr',
          gap: '40px'
        }}>
          <MenuManagement
            restaurant={restaurant}
            menu={menu}
            onDataChange={loadData}
          />
          <TableManagement
            restaurant={restaurant}
            tables={tables}
            setTables={setTables}
            onDataChange={loadData}
          />
        </div>
      </div>
    </div>
  );
};

export default ManagerDashboard;
